import React, { useState } from "react";
import { XIcon } from "@heroicons/react/solid";
import Modal from "../components/Modal";
import GoogleAuth from "../components/GoogleAuth";

function ContinueWithGoogle({ onClose }) {


  return (
    <Modal onClose={onClose}>
      <div className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-11/12 max-w-md">
        <div className="px-4 py-4 sm:px-6 flex flex-row-reverse">
          <button
            onClick={onClose}
            className="p-2 rounded-lg bg-white hover:bg-slate-100"
          >
            <XIcon
              className="w-5 text-gray h-5 font-bold "
              aria-hidden="true"
            />
          </button>
        </div>
        <div className="flex flex-row items-center justify-around mb-16">
          <div className="px-12">
            <h1 className="text-2xl text-center font-bold mb-2">Continue With Google</h1>
            <p className="text-sm text-slate-500 p-4">Use your the Google account associated with your school</p>
            <GoogleAuth/>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default ContinueWithGoogle;
